module.exports = __webpack_public_path__ + "static/media/ryan_cunningham_serious.5ed2e49f.png";